<template>
  <div role="banner" :class="stContentMenuClass">
    <nav class="st-content-menu-fixed">
      <div class="navbar">
        <figure class="st-logo" itemprop="associatedMedia image" itemscope itemtype="http://schema.org/ImageObject" data-component="image">
          <a href="http://www.straitstimes.com/" target="_blank">
              <img id="short_logo" src="~images_base/st-logo.svg" alt="Straitstimes logo" title="Straitstimes logo" />
              <img id="long_logo" src="~images_base/straits-times-logo.svg" alt="Straitstimes logo" title="Straitstimes logo" />
            </a>
        </figure>
        <div class="st-external-section">
          <template v-if="menu.length > 0">
            <ul>
                <li v-for="(item,i) in menu" :key="i" :class="{'current': isCurrentPage(item.href)}">
                <a v-if="item.module==='no'" :href="item.href" :title="item.title" :alt="item.title">{{item.name}}</a>
                <router-link v-else :title="item.title" :to="item.href">{{item.name}}</router-link>
                </li>
            </ul>
            <st-social-sharing-entry class="st-social-sharing-entry"></st-social-sharing-entry>
          </template>
          <template v-else>
            <st-social-button-group class="st-social-desktop nomenu"></st-social-button-group>
            <st-profile-menu class="st-social-desktop nomenu"></st-profile-menu>
          </template>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import StSocialSharingEntry from './StSocialSharingEntry/index.vue'
import StSocialButtonGroup from './StSocialSharingEntry/StSocialButtonGroup.vue'
import StProfileMenu from './StSocialSharingEntry/StProfileMenu.vue'

export default {
  components: {
    StSocialSharingEntry,
    StSocialButtonGroup,
    StProfileMenu
  },
  computed: Object.assign(mapState(['menu', 'header']), {
    stContentMenuClass () {
      return {
        'st-content-menu': true,
        'gradient': this.isTabletWidth && this.header &&
                   (this.header.bannerimage || this.header.bannervideo)
      }
    },
    isTabletWidth () {
      return this.$window.innerWidth < 600
    }
  }),
  methods: {
    isCurrentPage (href) {
      const pageName = window.location.pathname.split('/').pop() || 'index.html'
      return pageName === href.trim()
    }
  }
}
</script>

<style lang="scss">
.st-content-menu {
  position: relative;
  background: $stblue;
  height: 40px;

  @include breakpoint($d_menu_mobile) {
    height: 50px;
    background: $stblue;

    .st-content-menu-fixed {
      background: $stblue;
      height: 50px;
    }
  }

  &.gradient {
    position: absolute;
    background: transparent;
    width: 100%;
    top: 0;
    z-index: 99999;

    .st-content-menu-fixed {
      background: linear-gradient(to bottom, rgba(#000000, 0.4), rgba(#000000, 0));
    }
  }

  .st-content-menu-fixed {
    background-color: $stblue;
    left: 0;
    right: 0;
    z-index: 99999;
    height: 40px;

    @include breakpoint($d_menu_mobile) {
      height: 50px;
    }

    .navbar {
      @include container;

      position: relative;
      padding: 0 $outerSpacing;

      .st-logo {
        display: inline-block;

        #long_logo {
          display: none;
          width: 240px;
          height: 23px;
          padding-top: 14px;
          box-sizing: unset;

          @include breakpoint($d_menu_mobile) {
            display: block;
          }
        }

        #short_logo {
          display: block;
          width: 27px;
          height: 23px;
          padding-top: 8px;
          box-sizing: unset;

          @include breakpoint($d_menu_mobile) {
            display: none;
          }
        }
      }

      .st-external-section {
        position: absolute;
        right: $outerSpacing;
        top: 0;
        display: table;
        white-space: nowrap;
        height: 40px;

        @include breakpoint($d_menu_mobile) {
          height: 50px;
        }

        & > * {
          display: table-cell;
          vertical-align: middle;
        }

        & > ul {
          display: none;

          @include breakpoint($d_menu_mobile) {
            display: table-cell;
          }

          li {
            display: inline-block;
            margin-bottom: 0;
            text-align: center;
            font-size: 14px;
            text-transform: uppercase;
            opacity: 0.5;

            a {
              padding: 0 15px;
              font-family: $font-CuratorRegular;
              line-height: 1.4;
              color: #ffffff;
              text-transform: uppercase;
              cursor: pointer;
              border-bottom: none;
              text-decoration: none;
            }

            &.current {
              opacity: 1;

              a {
                cursor: default;
              }
            }
          }
        }

        & > .st-social-sharing-entry {
          & > * {
            vertical-align: middle;
          }
        }
      } // st-external-section
    }
  } // st-content-menu-fixed
} // st-content-menu
</style>
